import React from 'react';
import './ConfirmModal.css';

export const ConfirmModal = ({ title, subtitle, confirmLabel, cancelLabel, onConfirm, onCancel, loading }) => (
  <div className="ssr-modal-overlay">
    <div className="ssr-modal">
      <h2 className="ssr-modal-title">{title}</h2>
      <p className="ssr-modal-subtitle">{subtitle}</p>
      <button className="ssr-modal-btn-outlined" onClick={onConfirm} disabled={loading}>
        {loading ? 'Loading...' : confirmLabel}
      </button>
      <button className="ssr-modal-btn-black" onClick={onCancel} disabled={loading}>
        {cancelLabel}
      </button>
    </div>
  </div>
);
